module.exports = __webpack_public_path__ + "93d575e21fa43178a4c88575970d09f4.svg";